import { Gender } from "./Actor";

/**
 * An outfit from the Creator API. `name` is the game's outfit id; it is what
 * trainings store (actor.outfit, SetOutfit.outfitName), so it must stay stable.
 */
export interface Outfit {
  name: string;
  malePreviewUri?: string;
  femalePreviewUri?: string;
}

/**
 * Every outfit name referenced anywhere in a training: actors and take actor
 * states (`outfit`) and SetOutfit interactions (`outfitName`).
 */
export function collectOutfitNames(value: unknown): string[] {
  const names = new Set<string>();
  const walk = (node: unknown) => {
    if (Array.isArray(node)) {
      node.forEach(walk);
      return;
    }
    if (!node || typeof node !== "object") return;

    Object.entries(node).forEach(([key, child]) => {
      if ((key === "outfit" || key === "outfitName") && typeof child === "string") {
        if (child) names.add(child);
      } else {
        walk(child);
      }
    });
  };

  walk(value);
  return Array.from(names);
}

/** Preview for the given gender, falling back to the other gender's render. */
export function getOutfitPreviewUri(
  outfit: Outfit | undefined,
  gender?: Gender
): string | undefined {
  if (!outfit) return undefined;

  return gender === Gender.female
    ? outfit.femalePreviewUri ?? outfit.malePreviewUri
    : outfit.malePreviewUri ?? outfit.femalePreviewUri;
}
